import { render, staticRenderFns } from "./ShareWechatDialog.vue?vue&type=template&id=0d7d6a2d&scoped=true&"
import script from "./ShareWechatDialog.vue?vue&type=script&lang=js&"
export * from "./ShareWechatDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareWechatDialog.vue?vue&type=style&index=0&id=0d7d6a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d6a2d",
  null
  
)

export default component.exports